import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHamburger,
  faUtensils,
  faBeer,
  faCut,
  faDumbbell,
  faCar,
} from "@fortawesome/free-solid-svg-icons";

const BusinessTypes = () => (
  <section id="businesstypes" className="util__section businesstypes__root">
    <div className="util__container">
      <h2 className="businesstypes__title">
        Carte Verte, pour quels commerces ?
      </h2>
      <p className="businesstypes__description">
        Le service Carte Verte est adapté à différents types de commerces.
      </p>
      <div className="businesstypes__grid">
  <div className="businesstypes__item">
          <FontAwesomeIcon icon={faHamburger} className="businesstypes__icon" />
          <p>Fast food</p>
        </div>
        <div className="businesstypes__item">
          <FontAwesomeIcon icon={faUtensils} className="businesstypes__icon" />
          <p>Restaurants</p>
        </div>
        <div className="businesstypes__item">
          <FontAwesomeIcon icon={faBeer} className="businesstypes__icon" />
          <p>Bars</p>
        </div>
        <div className="businesstypes__item">
          <FontAwesomeIcon icon={faCut} className="businesstypes__icon" />
          <p>Salons de coiffure</p>
        </div>
        <div className="businesstypes__item">
          <FontAwesomeIcon icon={faDumbbell} className="businesstypes__icon" />
          <p>Salles de sport</p>
        </div>
        <div className="businesstypes__item">
          <FontAwesomeIcon icon={faCar} className="businesstypes__icon" />
          <p>Services</p>
        </div>
      </div>
    </div>
  </section>
);

export default BusinessTypes;
